import { isBefore } from 'date-fns';

import doesAgendaItemStartWithinNextHour from './doesAgendaItemStartWithinNextHour';
import getIsAgendaItemCurrentlyLive from './getIsAgendaItemCurrentlyLive';

export default ({ type, video, agendaItem, hasPreviewFinished }) => {
  if (!video) return;

  const {
    video: url,
    preview_video: previewVideo,
    enrollment_waitlist_status: enrollmentStatus,
    start_at: eventStartAt,
    end_at: eventEndAt,
  } = video.data;

  const isEnrolled = enrollmentStatus === 'enrolled';
  let src;

  switch (type) {
    case 'on-demand':
      src = url;
      break;
    case 'live': {
      const agendaItemUrl = agendaItem?.content?.is_embedded ? agendaItem.content.url : '';
      if (!isEnrolled && isBefore(new Date(), new Date(eventEndAt))) {
        src = previewVideo || '';
        break;
      } else if (!isEnrolled) {
        src = '';
        break;
      }
      if (getIsAgendaItemCurrentlyLive({ agendaItem })) {
        src = agendaItemUrl;
      } else if (isBefore(new Date(), new Date(eventStartAt)) && !agendaItem) {
        src = previewVideo;
      } else if (doesAgendaItemStartWithinNextHour({ agendaItem })) {
        src = hasPreviewFinished ? agendaItemUrl : previewVideo;
      }
      break;
    }
    default:
      break;
  }

  return src;
};
